import type { PageSize } from '@lokalise/louis';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type ContentEngineState = {
    groupIds: string[];
    expandedGroupIds: string[];
    pageNumber: number;
    limit: PageSize;
    selectedIds: string[];
};

const initialPageNumber = 1;
const initialLimit = 25;

const initialState: ContentEngineState = {
    groupIds: [],
    expandedGroupIds: [],
    pageNumber: initialPageNumber,
    limit: initialLimit,
    selectedIds: [],
};

const contentEngineSlice = createSlice({
    name: 'content-engine-fe',
    initialState,
    reducers: {
        setGroupIds: (state, { payload }: PayloadAction<{ groupIds: string[] }>) => {
            state.groupIds = payload.groupIds;
            state.expandedGroupIds = [];
        },
        toggleGroup: (state, { payload }: PayloadAction<{ groupId: string; isToggled: boolean }>) => {
            if (payload.isToggled) {
                state.expandedGroupIds = state.expandedGroupIds.filter((groupId) => groupId !== payload.groupId);
            } else {
                state.expandedGroupIds = [...state.expandedGroupIds, payload.groupId];
            }
        },
        toggleAll: (state, { payload }: PayloadAction<{ isToggled: boolean }>) => {
            if (payload.isToggled) {
                state.expandedGroupIds = [];
            } else {
                state.expandedGroupIds = state.groupIds;
            }
        },
        resetPage: (state) => {
            state.pageNumber = initialPageNumber;
        },
        setPagination: (state, { payload }: PayloadAction<{ pageNumber: number; limit: PageSize }>) => {
            state.pageNumber = payload.pageNumber;
            state.limit = payload.limit;
        },
        addSelectedRowId: (state, { payload }: PayloadAction<{ id: string }>) => {
            state.selectedIds = [...state.selectedIds, payload.id];
        },
        removeSelectedRowId: (state, { payload }: PayloadAction<{ id: string }>) => {
            state.selectedIds = state.selectedIds.filter((id) => id !== payload.id);
        },
        setSelectedRowIds: (state, { payload }: PayloadAction<string[]>) => {
            state.selectedIds = [...payload];
        },
    },
});

export default contentEngineSlice.reducer;

const {
    setGroupIds,
    toggleGroup,
    toggleAll,
    setPagination,
    resetPage,
    addSelectedRowId,
    removeSelectedRowId,
    setSelectedRowIds,
} = contentEngineSlice.actions;

export const contentEngineActions = {
    setGroupIds,
    toggleGroup,
    toggleAll,
    setPagination,
    resetPage,
    addSelectedRowId,
    removeSelectedRowId,
    setSelectedRowIds,
};
